import React, { useState } from 'react';
import cardImage from '../img/envision/casestudies/cardsimages/clientspekingimage.JPG';
import cardImage2 from '../img/envision/casestudies/cardsimages/tatamotors.JPG';
import cardImage3 from '../img/envision/casestudies/cardsimages/thridicarimg.JPG';
import { Link } from 'react-router-dom';

const CasestudiesCards = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div style={{ textAlign: 'center' }}>

            <div
                className="row justify-content-center"
                style={{
                    padding: '20px',
                    backgroundColor: '#fff',
                    gap: '20px',
                    width: '100%',
                }}
            >
                {/* Card 1 */}
                <div
                    className="col-lg-3 col-md-4 col-sm-6"
                    style={{ padding: '15px' }}
                >
                    <div
                        style={{
                            height: '410px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            textAlign: 'center',
                            transition: 'background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            overflow: 'hidden',
                            backgroundColor: hoveredIndex === 0 ? 'rgb(7 134 159)' : '',
                            transform: hoveredIndex === 0 ? 'scale(1.05)' : 'scale(1)', // Zoom effect
                        }}
                        onMouseEnter={() => setHoveredIndex(0)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <img
                            src={cardImage}
                            alt="Card 1"
                            style={{
                                width: '100%',
                                height: '183px',
                                objectFit: 'cover',
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px',
                                transition: 'opacity 0.3s ease',
                                opacity: hoveredIndex === 0 ? 0.8 : 1,
                            }}
                        />
                        <p style={{ marginBottom: '10px', color: '#000', textAlign: 'left', fontWeight: 'bold', marginLeft: '15px', marginRight: '15px', fontSize: "24px" }}>
                            Speak at Tesla LIVE 2024
                        </p>
                        <p style={{
                            textAlign: 'justify',
                            position: 'relative',
                            left: '0',
                            right: '0',
                            marginLeft: '15px',
                            marginRight: '15px',
                            color: '#000'
                        }}>
                            Las Vegas (May 9 – May 12) | Berlin (May 31 – June 2) —–We are excited for the opportunity to meet with you again personally or virtually!
                        </p>

                        {/* Learn More Text with Arrow */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexGrow: 1,
                            }}
                        >
                            <Link
                                to="/your-target-page"
                                style={{
                                    color: 'rgb(244 207 48)',
                                    textDecoration: 'none',
                                    fontSize: '16px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    border: '2px solid #000',
                                    borderRadius: '50px',
                                    background: '#000',
                                    padding: '10px 20px',
                                    color: '#fff',
                                }}
                            >
                                Learn More <span style={{ marginLeft: '5px' }}>→</span>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Card 2 */}
                <div
                    className="col-lg-3 col-md-4 col-sm-6"
                    style={{ padding: '15px' }}
                >
                    <div
                        style={{
                            height: '410px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            textAlign: 'center',
                            transition: 'background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            overflow: 'hidden',
                            backgroundColor: hoveredIndex === 1 ? 'rgb(7 134 159)' : '',
                            transform: hoveredIndex === 1 ? 'scale(1.05)' : 'scale(1)', // Zoom effect
                        }}
                        onMouseEnter={() => setHoveredIndex(1)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <img
                            src={cardImage2}
                            alt="Card 2"
                            style={{
                                width: '100%',
                                height: '183px',
                                objectFit: 'cover',
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px',
                                transition: 'opacity 0.3s ease',
                                opacity: hoveredIndex === 1 ? 0.8 : 1,
                            }}
                        />
                        <p style={{ marginBottom: '10px', color: '#000', textAlign: 'center', fontWeight: 'bold', marginLeft: '15px', marginRight: '15px', fontSize: "24px" }}>
                            Tata as a Service with line Planning
                        </p>
                        <p style={{
                            textAlign: 'justify',
                            position: 'relative',
                            left: '0',
                            right: '0',
                            marginLeft: '15px',
                            marginRight: '15px',
                            color: '#000'
                        }}>
                            The time is now for medium-sized manufacturers to take it to the next level and challenge complexity head-on.
                        </p>

                        {/* Learn More Text with Arrow */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexGrow: 1,
                            }}
                        >
                            <Link
                                to="/your-target-page"
                                style={{
                                    color: 'rgb(244 207 48)',
                                    textDecoration: 'none',
                                    fontSize: '16px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    border: '2px solid #000',
                                    borderRadius: '50px',
                                    background: '#000',
                                    padding: '10px 20px',
                                    color: '#fff',
                                }}
                            >
                                Learn More <span style={{ marginLeft: '5px' }}>→</span>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Card 3 */}
                <div
                    className="col-lg-3 col-md-4 col-sm-6"
                    style={{ padding: '15px' }}
                >
                    <div
                        style={{
                            height: '410px',
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            textAlign: 'center',
                            transition: 'background-color 0.3s ease, opacity 0.3s ease, transform 0.3s ease',
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            overflow: 'hidden',
                            backgroundColor: hoveredIndex === 2 ? 'rgb(7 134 159)' : '',
                            transform: hoveredIndex === 2 ? 'scale(1.05)' : 'scale(1)', // Zoom effect
                        }}
                        onMouseEnter={() => setHoveredIndex(2)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <img
                            src={cardImage3}
                            alt="Card 3"
                            style={{
                                width: '100%',
                                height: '183px',
                                objectFit: 'cover',
                                borderTopLeftRadius: '8px',
                                borderTopRightRadius: '8px',
                                transition: 'opacity 0.3s ease',
                                opacity: hoveredIndex === 2 ? 0.8 : 1,
                            }}
                        />
                        <p style={{ marginBottom: '10px', color: '#000', textAlign: 'center', fontWeight: 'bold', marginLeft: '15px', marginRight: '15px', fontSize: "24px" }}>
                            Audi thrives with 3D Plant Simulation
                        </p>
                        <p style={{
                            textAlign: 'justify',
                            position: 'relative',
                            left: '0',
                            right: '0',
                            marginLeft: '15px',
                            marginRight: '15px',
                            color: '#000'
                        }}>
                            Audi Hungary achieves added engineering value by switching from 2D to 3D models for manufacturing simulation.
                        </p>

                        {/* Learn More Text with Arrow */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexGrow: 1,
                            }}
                        >
                            <Link
                                to="/your-target-page"
                                style={{
                                    color: 'rgb(244 207 48)',
                                    textDecoration: 'none',
                                    fontSize: '16px',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    border: '2px solid #000',
                                    borderRadius: '50px',
                                    background: '#000',
                                    padding: '10px 20px',
                                    color: '#fff',
                                }}
                            >
                                Learn More <span style={{ marginLeft: '5px' }}>→</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default CasestudiesCards;
